module.exports = __webpack_public_path__ + "static/media/vip-background.adc42b28.jpg";